import { render, staticRenderFns } from "./memberLabelTab.vue?vue&type=template&id=334d64ec&lang=pug"
import script from "./memberLabelTab.vue?vue&type=script&lang=js"
export * from "./memberLabelTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports